import { useLocation } from 'react-router-dom'

/** Thông báo một lần truyền qua navigate(..., { state: { flash } }) */
export function Flash() {
  const { state } = useLocation() as { state?: { flash?: string } | null }
  if (!state?.flash) return null
  return (
    <p className="flash-ok" role="status">
      <i className="fa-solid fa-circle-check" aria-hidden /> {state.flash}
    </p>
  )
}
